webpackJsonp([49],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3BBE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6L8A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9F4c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const storeID = 1
const appVersion = 1.1





// function _appVersion(){
// 	return appVersion;
// }

// function _storeid(){
// 	return storeID;
// }



module.exports = {
  appversion: appVersion,
  storeID: storeID
}

/***/ }),

/***/ "FMur":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kf48":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
const urlConfig = {
  development: {
    plapi: "http://php-api.test1.zhaojiafang.com/api",
    extapi: "http://extapi.test1.zhaojiafang.com/v1",
    productionDetailUrl: "http://detail.test1.zhaojiafang.com", // sku详情前缀
    main: "http://www.test1.zhaojiafang.com", // 主站前缀
    newMain: "http://seller.test1.zhaojiafang.com",
    search: "http://search.test1.zhaojiafang.com", // 搜索前缀
    member: "http://member.test1.zhaojiafang.com", // 用户前缀
    mainApi: "http://nodejs-api.test1.zhaojiafang.com/v1", //主站请求前缀
    login: "http://login.test1.zhaojiafang.com", // 登录前缀
    user: "http://sc.test1.zhaojiafang.com",
    erp: "http://daifa.test1.zhaojiafang.com",
    qiniu: "http://qiniutest.zhaojiafang.com",
    pages: "http://pages.test1.zhaojiafang.com"
  },
  production: {
    plapi: "http://api-pl-mobile.zhaojiafang.com/api",
    extapi: "http://extapi.zhaojiafang.com/v1",
    productionDetailUrl: "http://detail.zhaojiafang.com",
    main: "http://www.zhaojiafang.com",
    newMain: "http://seller.zhaojiafang.com",
    search: "http://search.zhaojiafang.com",
    member: "http://member.zhaojiafang.com",
    mainApi: "http://api.zhaojiafang.com/v1",
    login: "http://login.zhaojiafang.com",
    user: "http://sc.zhaojiafang.com",
    erp: "http://daifa.zhaojiafang.com",
    qiniu: "http://qiniu.zhaojiafang.com",
    pages: "http://pages.zhaojiafang.com"
  },
  test1: {
    plapi: "http://php-api.test1.zhaojiafang.com/api",
    extapi: "http://extapi.test1.zhaojiafang.com/v1",
    productionDetailUrl: "http://detail.test1.zhaojiafang.com",
    main: "http://www.test1.zhaojiafang.com",
    newMain: "http://seller.test1.zhaojiafang.com",
    search: "http://search.test1.zhaojiafang.com",
    member: "http://member.test1.zhaojiafang.com",
    mainApi: "http://nodejs-api.test1.zhaojiafang.com/v1",
    login: "http://login.test1.zhaojiafang.com",
    user: "http://sc.test1.zhaojiafang.com",
    erp: "http://daifa.test1.zhaojiafang.com",
    qiniu: "http://qiniutest.zhaojiafang.com",
    pages: "http://pages.test1.zhaojiafang.com"
  },
  test2: {
    plapi: "http://php-api.test2.zhaojiafang.com/api",
    extapi: "http://extapi.test2.zhaojiafang.com/v1",
    productionDetailUrl: "http://detail.test2.zhaojiafang.com",
    main: "http://www.test2.zhaojiafang.com",
    search: "http://search.test2.zhaojiafang.com",
    member: "http://member.test2.zhaojiafang.com",
    mainApi: "http://nodejs-api.test2.zhaojiafang.com/v1",
    login: "http://login.test2.zhaojiafang.com",
    user: "http://sc.test2.zhaojiafang.com",
    erp: "http://daifa.test2.zhaojiafang.com",
    qiniu: "http://qiniutest.zhaojiafang.com"
  },
  test3: {
    plapi: "http://php-api.test3.zhaojiafang.com/api",
    extapi: "http://extapi.test3.zhaojiafang.com/v1",
    productionDetailUrl: "http://detail.test3.zhaojiafang.com",
    main: "http://www.test3.zhaojiafang.com",
    search: "http://search.test3.zhaojiafang.com",
    member: "http://member.test3.zhaojiafang.com",
    mainApi: "http://nodejs-api.test3.zhaojiafang.com/v1",
    login: "http://login.test3.zhaojiafang.com",
    user: "http://sc.test3.zhaojiafang.com",
    erp: "http://daifa.test3.zhaojiafang.com",
    qiniu: "http://qiniutest.zhaojiafang.com"
  },
  stage: {
    plapi: "http://php-api.stage.zhaojiafang.com/api",
    extapi: "http://extapi.staging.zhaojiafang.com/v1",
    productionDetailUrl: "http://detail.stage.zhaojiafang.com",
    main: "http://www.stage.zhaojiafang.com",
    search: "http://search.stage.zhaojiafang.com",
    member: "http://member.stage.zhaojiafang.com",
    mainApi: "http://nodejs-api.stage.zhaojiafang.com/v1",
    login: "http://login.stage.zhaojiafang.com",
    user: "http://sc.stage.zhaojiafang.com",
    erp: "http://daifa.stage.zhaojiafang.com",
    qiniu: "http://qiniutest.zhaojiafang.com"
  }
};
/* unused harmony export urlConfig */


const APP_ENV = "production";
/* unused harmony export APP_ENV */


const CurrentEnvPrefix = urlConfig[APP_ENV];
/* harmony export (immutable) */ __webpack_exports__["a"] = CurrentEnvPrefix;



/***/ }),

/***/ "N1Qb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'App',
  mounted: function mounted() {
    this.Common.addSPM(this.$route.query.spm);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8068a754","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('zjf-toaster')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("fNgU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js



vue_esm["default"].use(vue_router_esm["a" /* default */]);

var routes = [{
  path: "/newgoods",
  name: "newgoods",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Vzjr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/hotsearch",
  name: "hotsearch",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xJ1D")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/brand",
  name: "brand",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("OKst")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/navigation",
  name: "navigation",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2bYq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/wetchat",
  name: "wetchat",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1WQx")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/seasongoods",
  name: "seasongoods",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4XIM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/newtowel",
  name: "newtowel",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("b1/P")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/winprize",
  name: "winprize",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(44)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("y4mk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/goodsupplier",
  name: "goodsupplier",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lnXN")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/topsupplier",
  name: "topsupplier",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("i6fH")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/topstore",
  name: "topstore",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(46)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("DZOF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/purchase", //采购节
  name: "purchase",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ejLL")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/tianmao", //天猫二手店
  name: "tianmao",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4nul")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/tianmao_detail", //天猫二手店
  name: "tianmao_detail",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("DsEA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/yiqing", //疫情专题
  name: "yiqing",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MBAr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/repeatwork", //企业复工
  name: "repeatwork",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PvdM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/findgoods", //发现好货
  name: "findgoods",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wQdD")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/hotstore", //人气商家
  name: "hotstore",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("AxJ8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/jiafangcheng", //家纺城专题
  name: "jiafangcheng",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dQEI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/zhounian", //4周年
  name: "zhounian",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("M/1b")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/channel", //文章频道
  name: "channel",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(43)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tydn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/articlelist", //文章列表
  name: "articlelist",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(40)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Pf+l")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/articledetail", //文章详情
  name: "articledetail",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MvSn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/zjfrecord", //找家纺大事记
  name: "zjfrecord",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iQo0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/videolist", //视频列表
  name: "videolist",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1WAS")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/videodetail", //视频详情
  name: "videodetail",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("K0Gj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/xuanpin", //直播选品
  name: "xuanpin",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("e2Au")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mayi", //蚂蚁仓
  name: "mayi",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("anH9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  //收藏夹
  path: "/favorites",
  name: "favorites",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2E/6")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "*", //
  name: "unfind",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7Rwl")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/zhaohuo", //找货助手
  name: "zhaohuo",
  // component: resolve => require(["@/components/special/zhaohuo"], resolve)
  redirect: function redirect(to) {
    window.location.href = 'https://www.zhaojiafang.com';
  }
}, {
  path: "/car", //找货助手
  name: "car",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ql0N")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/landingPage", //落地页
  name: "landingPage",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("38SY")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/antbarn", //蚂蚁仓频道招商
  name: "antbarn",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3Rbi")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/basketball", //篮球赛
  name: "basketball",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(37)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("I8B0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/basketballstyle", //篮球赛
  name: "basketballstyle",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wLp9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/springclose", //春节不打烊
  name: "springclose",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XSaj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/newyear", //新年活动
  name: "newyear",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("t609")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/feedback", // 投诉
  name: "feedback",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8xe4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/montage", // 红馆拼接广告
  name: "montage",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("zidh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/transportnew", // 运费测算
  name: "transportnew",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yhqV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/fuwuhome", // 服务市场首页
  name: "fuwuhome",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("L5Uk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/fuwulist", // 服务市场列表
  name: "fuwulist",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(42)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Am9z")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/fuwudetail", // 服务市场详情
  name: "fuwudetail",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("uGcn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/fuwuindex", // 服务商首页
  name: "fuwuindex",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("P8E2")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/onlineretailertool", // 新页面onlineretailertool
  name: "onlineretailertool",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("d3ql")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/brandSecondaryPage",
  name: "brandSecondaryPage",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(39)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("39Q8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}];

/** 一个只允许访问找货助手的站点，且剔除品牌信息 */
if (location.host === 'zhaohuo.mqgou.com') {
  try {
    document.title = '找货助手';
  } catch (e) {
    //do nothing
  }
  routes = [{
    path: '/',
    name: 'root',
    redirect: '/zhaohuo'
  }, {
    path: "/zhaohuo", //找货助手
    name: "zhaohuo",
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MTAT")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }];
} else {
  var setHead = function setHead() {
    // ===== 1. title =====
    document.title = '找家纺就上找家纺网！';

    // ===== 2. favicon =====
    var iconLink = document.querySelector('#icon-link');
    if (!iconLink) {
      iconLink = document.createElement('link');
      iconLink.id = 'icon-link';
      iconLink.rel = 'icon';
      document.head.appendChild(iconLink);
    }
    iconLink.href = 'https://qiniu.zhaojiafang.com/data/upload/shop/icon/zjf.png?t=' + Date.now();

    // ===== 3. keywords =====
    var keywords = document.querySelector('meta[name="keywords"]');
    if (!keywords) {
      keywords = document.createElement('meta');
      keywords.name = 'keywords';
      document.head.appendChild(keywords);
    }
    keywords.content = '找家纺网,找家纺平台,找家纺网,591网销,591网销导航,dss网销导航,591家纺,591家纺网,叠石桥网销导航';

    // ===== 4. description =====
    var description = document.querySelector('meta[name="description"]');
    if (!description) {
      description = document.createElement('meta');
      description.name = 'description';
      document.head.appendChild(description);
    }
    description.content = '找家纺就上找家纺网！591网销,591网销导航,dss网销导航,591家纺,591家纺网,叠石桥网销导航,专注于家纺供应链一站式解决方案！';
  };

  setHead();
}

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: "history",
  base: "/",
  routes: routes
}));
// EXTERNAL MODULE: ./node_modules/vue-ydui/dist/ydui.rem.js
var ydui_rem = __webpack_require__("r8FW");
var ydui_rem_default = /*#__PURE__*/__webpack_require__.n(ydui_rem);

// EXTERNAL MODULE: ./node_modules/vue-ydui/dist/ydui.px.css
var ydui_px = __webpack_require__("l7hk");
var ydui_px_default = /*#__PURE__*/__webpack_require__.n(ydui_px);

// EXTERNAL MODULE: ./src/global/css/styles.css
var styles = __webpack_require__("3BBE");
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);

// EXTERNAL MODULE: ./src/global/css/style.css
var css_style = __webpack_require__("6L8A");
var style_default = /*#__PURE__*/__webpack_require__.n(css_style);

// EXTERNAL MODULE: ./src/global/css/font-awesome/css/font-awesome.min.css
var font_awesome_min = __webpack_require__("FMur");
var font_awesome_min_default = /*#__PURE__*/__webpack_require__.n(font_awesome_min);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("mw3O");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./config/urlprefix.js
var urlprefix = __webpack_require__("Kf48");

// CONCATENATED MODULE: ./src/api/config.js



var APP_ENV = "production";



/* harmony default export */ var config = ({
  url: "/route",

  baseURL: urlprefix["a" /* CurrentEnvPrefix */].mainApi, //http://192.168.2.105:3006/v1//http://apistaging.zhaojiafang.com/v1//http://api.zhaojiafang.com/v1

  transformRequest: [function (data) {
    // 为了避免qs格式化时对内层对象的格式化先把内层的对象转为
    data.CustData = stringify_default()(data.CustData);
    // 由于使用的form-data传数据所以要格式化
    data = lib_default.a.stringify(data);
    return data;
  }],

  transformResponse: [function (data) {
    return data;
  }],

  headers: { "Content-Type": "application/x-www-form-urlencoded" },

  authparams: {
    AppVersion: "3.11",
    Format: "json",
    SystemName: "PC",
    key: "",
    storeid: "0",
    SignCodeKey: "H5SIGNKEYZJFk3029ydhsuwei192bmch",
    timestamp: new Date().getTime(),
    nosign: "nodejs.sign.no"
  },

  params: {},

  data: {},

  timeout: 60000,

  withCredentials: false, // default

  responseType: "json", // default

  maxContentLength: 2000,

  maxRedirects: 5, // default

  paramsSerializer: function paramsSerializer(params) {
    return lib_default.a.stringify(params);
  },

  onUploadProgress: function onUploadProgress(progressEvent) {
    // Do whatever you want with the native progress event
  },
  onDownloadProgress: function onDownloadProgress(progressEvent) {
    // Do whatever you want with the native progress event
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300; // default
  }
});
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("lbHh");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./src/global/js/memberinfo.js

var key_member = 'member_info';

var _getMember = function _getMember() {
	var data = localStorage.getItem(key_member);
	if (data) {
		try {
			return JSON.parse(data);
		} catch (err) {
			return {};
		}
	}
	return {};
};

var memberinfo__saveMember = function _saveMember(member) {
	if (member) {
		//先查找本地存储的用户信息，如果要存储的用户信息没有key，就用本地的替换
		var mOld = _getMember();
		if (mOld && !member.key) {
			member.key = mOld.key;
		}
		localStorage.setItem(key_member, stringify_default()(member));
	} else {
		localStorage.removeItem(key_member);
	}
};

var MemberInfo = {
	getMemberInfo: function getMemberInfo() {
		return _getMember();
	},
	saveMemberInfo: function saveMemberInfo(member) {
		memberinfo__saveMember(member);
	},
	isLogin: function isLogin() {
		var member = _getMember();
		if (member && member.key) {
			return true;
		}
		return false;
	}
};

/* harmony default export */ var memberinfo = (MemberInfo);
// CONCATENATED MODULE: ./src/api/API.js









var MD5 = __webpack_require__("eCz2");

var API_initKey = function initKey() {
  var m = memberinfo.getMemberInfo();
  var c = js_cookie_default.a.get("key");
  if (!lodash_default.a.isEmpty(m) || !lodash_default.a.isEmpty(c)) {
    config.authparams.key = m.key || c;
  }
};

var API_initStoreId = function initStoreId() {
  var id = API__getStoreid();
  config.authparams.storeid = id;
};

var _saveStoreid = function _saveStoreid(store_id) {
  localStorage.setItem("storeid", store_id);
};

var API__getStoreid = function _getStoreid() {
  var id = config.authparams.storeid;
  if (!id) {
    id = localStorage.getItem("storeid");
  }
  return id;
};

//获取登录权限
API_initKey();
//获取app id
API_initStoreId();

var API_API = function () {
  function API() {
    classCallCheck_default()(this, API);
  }

  createClass_default()(API, [{
    key: "get",

    //获取已授权列表
    value: function get(param) {
      var _params = {};
      config.data = {};
      lodash_default.a.map(config.authparams, function (value, key) {
        _params[key] = value;
      });

      config.params = _params;
      lodash_default.a.extend(config.params, param.param);
      config.params = this.signCodeRequest(config.params);
      return axios_default.a.get(param.api, config);
    }
    //添加授权

  }, {
    key: "post",
    value: function post(param) {
      var _params = {};
      config.params = {};
      lodash_default.a.map(config.authparams, function (value, key) {
        _params[key] = value;
      });
      config.data = _params;
      if (param.headers) {
        config.headers = param.headers;
      }
      lodash_default.a.extend(config.data, param.param);
      config.data = this.signCodeRequest(config.data);
      return axios_default.a.post(param.api, {}, config);
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(param, fileName, type, callbackProgress, callbackResult) {
      var _params = {};
      //拼接参数begin
      //获取公共参数到_params中
      lodash_default.a.map(config.authparams, function (value, key) {
        _params[key] = value;
      });
      //将公共参数和页面参数合并到_params中
      lodash_default.a.extend(_params, param.param);
      delete _params[fileName];
      //生成签名
      _params = this.signCodeRequest(_params);
      //当type为真时表示上传文件，node.js服务器需要把参数拼接到url中
      var api = config.baseURL + param.api;
      if (type) {
        lodash_default.a.map(_params, function (value, key) {
          if (api.indexOf("?") < 0) {
            api += "?";
          }
          api += "&" + key + "=" + value;
        });
      }
      //将请求参数转为表单
      var _formData = new FormData();
      _formData.append(fileName, param.param[fileName]);
      lodash_default.a.map(_params, function (value, key) {
        _formData.append(key, value);
      });
      return axios_default()({
        url: api,
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: function onUploadProgress(progressEvent) {
          //原生获取上传进度的事件
          if (progressEvent.lengthComputable) {
            //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
            var _progress = (progressEvent.loaded / progressEvent.total * 100 | 0) + "%";
            callbackProgress(_progress);
          }
        },
        data: _formData
      }).then(function (res) {
        // console.log('上传成功');
        callbackResult(res);
      }).catch(function (error) {
        // console.log('上传失败')
        callbackResult(error);
      });
    }

    //资源上传

  }, {
    key: "uploadResource",
    value: function uploadResource(param, callbackProgress, callbackResult) {
      return axios_default()({
        url: urlprefix["a" /* CurrentEnvPrefix */].main + param.api, //BASE_URL + '/handler/material/upload',
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: function onUploadProgress(progressEvent) {
          //原生获取上传进度的事件
          if (progressEvent.lengthComputable) {
            //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
            var _progress = (progressEvent.loaded / progressEvent.total * 100 | 0) + "%";
            callbackProgress(_progress);
          }
        },
        data: param.formdata
      }).then(function (res) {
        // console.log('上传成功');
        callbackResult(res);
      }).catch(function (error) {
        // console.log('上传失败')
        callbackResult(error);
      });
    }
  }, {
    key: "reqSuccess",
    value: function reqSuccess(obj, msg) {
      obj.$message({
        message: msg,
        type: "success"
      });
    }
  }, {
    key: "reqFail",
    value: function reqFail(obj, msg) {
      obj.$message({
        message: msg,
        type: "success"
      });
    }
  }, {
    key: "setMKey",
    value: function setMKey(member) {
      config.authparams.key = member;
    }
  }, {
    key: "getMKey",
    value: function getMKey() {
      return config.authparams.key;
    }
  }, {
    key: "setStoreid",
    value: function setStoreid(store_id) {
      config.authparams.storeid = store_id;
      _saveStoreid(store_id);
    }
  }, {
    key: "getStoreid",
    value: function getStoreid() {
      var id = config.authparams.storeid;
      if (!id) {
        id = API__getStoreid();
      }
      return id;
    }
  }, {
    key: "signCodeRequest",
    value: function signCodeRequest(obj) {
      var newkeys = keys_default()(obj).sort();
      var newObj = {};
      var SignCode = "";
      newkeys.forEach(function (item, index) {
        if (item.indexOf(":") == -1 && item != "SignCodeKey") {
          var v = obj[item] == undefined ? "" : obj[item];
          newObj[item] = v;
          SignCode += v;
        }
      });
      SignCode += config.authparams.SignCodeKey;
      newObj["Sign"] = new MD5().update(SignCode).digest("hex");
      return newObj;
    }
  }]);

  return API;
}();

/* harmony default export */ var api_API = (API_API);
// CONCATENATED MODULE: ./src/api/ZJF.js






var ZJF__params = {};

var ZJF_initKey = function initKey() {
	var m = memberinfo.getMemberInfo();
	if (!lodash_default.a.isEmpty(m)) {
		config.authparams.key = m.key;
	}
};

//获取登录权限
ZJF_initKey();

var ZJF_ZJF = function () {
	function ZJF() {
		classCallCheck_default()(this, ZJF);
	}

	createClass_default()(ZJF, [{
		key: 'location',

		//获取已授权列表
		value: function location(param) {
			lodash_default.a.map(config.authparams, function (value, key) {
				param += '&' + key + '=' + value;
			});
			param += '&vuetype=1';
			window.location.href = param;
		}
	}]);

	return ZJF;
}();

/* harmony default export */ var api_ZJF = (ZJF_ZJF);
// CONCATENATED MODULE: ./src/global/js/helper.js


var isDebug = false;

var helper = {
	log: function log(msg) {
		if (isDebug) {
			console.log(msg);
		}
	},
	sortList: function sortList(type, val, arr, key) {
		//type:1数字,0字符
		//val:0升序,1降序
		return arr.sort(function (a, b) {
			var x = a[key];
			var y = b[key];
			if (type == 1) {
				if (val) {
					return x > y ? -1 : x < y ? 1 : 0;
				} else {
					return x < y ? -1 : x > y ? 1 : 0;
				}
			} else {
				if (val) {
					return x.localeCompare(y);
				} else {
					return y.localeCompare(x);
				}
			}
		});
	},
	htmltitle: function htmltitle(title) {
		document.title = title;
	}
};

/* harmony default export */ var js_helper = (helper);
// CONCATENATED MODULE: ./src/global/js/common.js





var common_api = new api_API();

var goods = [];
var store = [];

var sourec = {
  appversion: 1.0,
  fromWhere: { h5: "h5", ios: "iosapp", android: "androidapp" },
  isFromApp: false, //	是否来自app
  sfrom: "",
  key: "",
  isIos: "",
  isAndroid: "",
  plapi: urlprefix["a" /* CurrentEnvPrefix */].plapi, // 'http://api-pl-mobile.zhaojiafang.com/api',
  extapi: urlprefix["a" /* CurrentEnvPrefix */].extapi, // 'http://extapi.zhaojiafang.com/v1',
  productionUrl: urlprefix["a" /* CurrentEnvPrefix */].main, // 'http://www.zhaojiafang.com',//生产环境链接跳转的域名
  productionDetailUrl: urlprefix["a" /* CurrentEnvPrefix */].productionDetailUrl, // 'http://detail.zhaojiafang.com',//生产环境链接跳转的域名(带detail的)
  qiniu: urlprefix["a" /* CurrentEnvPrefix */].qiniu
};
var _barHeight = window.control ? window.control.getStateBarHeight() : 0;

var common__saveGoodsword = function _saveGoodsword(goodsword) {
  localStorage.setItem("goodsword", stringify_default()(goodsword));
};
var _getGoodsword = function _getGoodsword() {
  var goodsword = [];
  goodsword = JSON.parse(localStorage.getItem("goodsword"));
  return goodsword;
};
var common__saveStoreword = function _saveStoreword(storeword) {
  localStorage.setItem("storeword", stringify_default()(storeword));
};
var _getStoreword = function _getStoreword() {
  var storeword = [];
  storeword = JSON.parse(localStorage.getItem("storeword"));
  return storeword;
};
var _delGoodsword = function _delGoodsword() {
  localStorage.removeItem("goodsword");
};
var _delStoresword = function _delStoresword() {
  localStorage.removeItem("storeword");
};
var _urlParse = function _urlParse() {
  var obj = {};
  var reg = /[?&][^?&]+=[^?&%]+/g;
  var url = window.location.search;
  var arr = url.match(reg) || [];
  arr.forEach(function (item) {
    var tempArr = item.substring(1).split("=");
    var key = decodeURIComponent(tempArr[0]);
    var val = decodeURIComponent(tempArr[1]);
    obj[key] = val;
  });
  return obj;
};

var changePageHeader = function changePageHeader() {
  if (sourec.isFromApp) {
    document.getElementById("apptip").style.display = "none";
    if (document.getElementById("header")) {
      document.getElementById("header").style.display = "none";
      document.getElementById("h-content").style.cssText = "padding-top:0 !important;";
    }
  }
};
var common_patchUrl = function patchUrl(type, url) {
  return urlprefix["a" /* CurrentEnvPrefix */][type] + url;
};
function _addSpm(spm) {
  var params = { spm_code: spm };
  common_api.post({ api: "/ad/spm", param: params }).then(function (response) {});
}

var _common = {
  getSourec: function getSourec() {
    return sourec;
  },
  //	来自app的标识
  //是否APP过来，需隐藏头部
  setIsFromApp: function setIsFromApp() {
    return appversion;
    // sfrom = GetQueryString('isfrom');
    // if (sfrom && sfrom!='null') { isFromApp = sfrom.length > 0; }
    // // 默认是隐藏头部的；如果是从app过来的就隐藏，反之显示
    // if (isFromApp) { $("#header").css("display","none"); $("#bottom").css("display","none"); }
    // else { $("#header").css("display","block"); $("#bottom").css("display","block"); }
  },
  setGoodsword: function setGoodsword(goodsword) {
    if (!goods) {
      goods = [];
    }
    goods.push(goodsword);
    common__saveGoodsword(goods);
  },
  getGoodsword: function getGoodsword() {
    goods = _getGoodsword();
    return goods;
  },
  setStoreword: function setStoreword(storeword) {
    if (!store) {
      store = [];
    }
    store.push(storeword);
    common__saveStoreword(store);
  },
  getStoreword: function getStoreword() {
    store = _getStoreword();
    return store;
  },
  delGoodsword: function delGoodsword() {
    goods = _delGoodsword();
    return goods;
  },
  delStoresword: function delStoresword() {
    store = _delStoresword();
    return store;
  },
  urlParse: function urlParse() {
    param = _urlParse();
    return param;
  },
  init: function init() {
    var params = _urlParse(); //所以分割出来的参数
    sourec.key = params.key;
    // sourec.isFromApp = true;
    sourec.isFromApp = params.isfrom ? true : false;
    var u = navigator.userAgent;
    changePageHeader();
    var u = navigator.userAgent;
    sourec.isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    sourec.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    // appversion =params.appversion;
    // if(key){
    // 	//通过key请求用信息
    // 	//存储用户信息
    // }
  },
  openApp: function openApp(cb) {
    var href = "";
    //识别系统
    var u = navigator.userAgent;
    var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    var isChrome = window.navigator.userAgent.indexOf("Chrome") !== -1;
    if (isIos) {
      href = "appzhaojiafangcs://HomeZJFController";
    } else if (isAndroid) {
      href = "zhaojiafang://Home";
    }
    location.href = href;
    setTimeout(function () {
      location.href = "/common/downloadapp";
    }, 1000);
    setTimeout(function () {
      location.reload();
    }, 4000);
  },
  barHeight: function barHeight() {
    return _barHeight;
  },
  addSPM: function addSPM(spm) {
    _addSpm(spm);
  },
  getlinkToErpUrl: function getlinkToErpUrl(url, query, member_center) {
    var token = js_cookie_default.a.get("erp_access_token");
    if (member_center) {
      return common_patchUrl("user", url + "?token=" + (token + query));
    }
    return common_patchUrl("erp", url + "?token=" + (token + query));
  }
};

/* harmony default export */ var common = (_common);
// EXTERNAL MODULE: ./node_modules/vue-clipboard2/vue-clipboard.js
var vue_clipboard = __webpack_require__("wvfG");
var vue_clipboard_default = /*#__PURE__*/__webpack_require__.n(vue_clipboard);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/public/publictop.vue
//
//
//

/* harmony default export */ var publictop = ({
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3647f2c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/publictop.vue
var publictop_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zjf-header',{attrs:{"show-small-popover":""}})}
var publictop_staticRenderFns = []
var publictop_esExports = { render: publictop_render, staticRenderFns: publictop_staticRenderFns }
/* harmony default export */ var public_publictop = (publictop_esExports);
// CONCATENATED MODULE: ./src/components/public/publictop.vue
var publictop_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var publictop___vue_template_functional__ = false
/* styles */
var publictop___vue_styles__ = null
/* scopeId */
var publictop___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var publictop___vue_module_identifier__ = null
var publictop_Component = publictop_normalizeComponent(
  publictop,
  public_publictop,
  publictop___vue_template_functional__,
  publictop___vue_styles__,
  publictop___vue_scopeId__,
  publictop___vue_module_identifier__
)

/* harmony default export */ var components_public_publictop = (publictop_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/public/header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var header = ({
  data: function data() {
    return {
      CurrentEnvPrefix: urlprefix["a" /* CurrentEnvPrefix */],
      hotshow: false,
      hotkeyword: [],
      goodskeyword: [],
      tab: ["商品", "厂家"],
      tabnum: 0,
      goodssearch: true,
      searchlist: [],
      storesearchlist: [],
      list: [],
      brandlist: [],
      site_logo: {}
    };
  },

  methods: {
    tabsearchClick: function tabsearchClick(index, tab) {
      this.tabnum = index;
      if (tab === "批量铺货") {
        this.$router.push("/landingPage");
      }
      if (index == 1) {
        this.goodssearch = false;
      } else {
        this.goodssearch = true;
      }
      this.getHotKeyWord();
    },
    searchClick: function searchClick() {
      this.hotshow = true;
    },
    hiddensearch: function hiddensearch() {
      this.hotshow = false;
    },
    getHotKeyWord: function getHotKeyWord() {
      var _this2 = this;

      this.$Api.get({ api: "/fragment/hotkeywords" }).then(function (response) {
        _this2.hotkeyword = response.data.datas;
        if (_this2.goodssearch) {
          _this2.goodskeyword = _this2.hotkeyword.goods;
        } else {
          _this2.goodskeyword = _this2.hotkeyword.store;
        }
      });
    },
    uploadChange: function uploadChange(e) {
      var files = e.target.files[0];
      var _formData = new FormData();
      var _this = this;
      _formData.append("name", "card_z");
      _formData.append("key", this.$Api.getMKey());
      _formData.append("card_z", files);
      this.$Api.uploadResource({
        api: "/mobile/index.php?act=goods&op=search",
        formdata: _formData
      }, function (callbackProgress) {
        _this.$nextTick(function () {
          _this.progress = callbackProgress;
          // console.log(_this.progress)
        });
      }, function (callBackResult) {
        //处理数据，跳到goodslist页面
        var param = callBackResult.data || [];
        var result = param.length > 0 ? param[0] : null;
        var images = param.length > 0 ? param[1] : null;
        if (result || images) {
          var href = urlprefix["a" /* CurrentEnvPrefix */].main + "/shop/index.php?act=search&op=goods_search&goods_id_list=" + result + "&img=" + images;
          window.location.href = href;
        }
      }).then(function (response) {});
    },
    searchsureClick: function searchsureClick() {
      var keyword = this.$refs.inputname.value;
      this.kwsearchClick(keyword);
    },
    kwsearchClick: function kwsearchClick(keyword) {
      if (this.goodssearch) {
        this.Common.setGoodsword(keyword);
        window.location.href = urlprefix["a" /* CurrentEnvPrefix */].main + "/shop/index.php?act=search&op=index&keyword=" + keyword;
      } else {
        this.Common.setStoreword(keyword);
        window.location.href = urlprefix["a" /* CurrentEnvPrefix */].main + "/shop/?act=store_list&keyword=" + keyword;
      }
    },
    delword: function delword() {
      var _this3 = this;

      if (this.goodssearch) {
        this.$dialog.confirm({
          mes: "确定要删除全部历史搜索吗？",
          opts: function opts() {
            _this3.Common.delGoodsword();
            _this3.searchlist = _this3.Common.getGoodsword();
          }
        });
      } else {
        this.$dialog.confirm({
          mes: "确定要删除全部历史搜索吗？",
          opts: function opts() {
            _this3.Common.delGoodsword();
            _this3.storesearchlist = _this3.Common.getStoreword();
          }
        });
      }
    },
    getList: function getList() {
      var _this4 = this;

      this.$Api.get({
        api: "/ad/list",
        param: { ad_type: "commonsearch.history.ads" }
      }).then(function (response) {
        var datas = response.data.datas;
        var lastindex = _this4.$cookie.get("hhtj") || "";
        if (lastindex == "") {
          lastindex = 0;
          _this4.$cookie.set("hhtj", lastindex, "1D");
        } else {
          lastindex = lastindex == 0 ? 1 : 0;
        }
        _this4.$cookie.set("hhtj", lastindex, "1D");
        _this4.list = datas[lastindex];
      });
    },
    getBrandList: function getBrandList() {
      var _this5 = this;

      this.$Api.get({ api: "/ad/list", param: { ad_type: "commonsearch.brandlist" } }).then(function (response) {
        _this5.brandlist = response.data.datas;
      });
    },
    getLogo: function getLogo() {
      var _this6 = this;

      this.$Api.get({
        api: this.Common.getSourec().plapi + "/setting/fragment_setting_list"
      }).then(function (response) {
        if (response.data.ResponseStatus == 0) {
          var data = response.data.datas;
          _this6.site_logo = data.site_logo;
        } else {
          _this6.$dialog.toast({ mes: response.data.ResponseMsg });
        }
      });
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted: function mounted() {
    this.getHotKeyWord();
    this.getLogo();
    window.addEventListener("scroll", this.handleScroll);
    this.searchlist = this.Common.getGoodsword() || [];
    for (var i = 0; i < this.searchlist.length; i++) {
      for (var m = 0; m < this.searchlist.length; m++) {
        if (i != m && this.searchlist[i] == this.searchlist[m]) {
          this.searchlist.splice(m, 1);
        }
      }
    }
    this.storesearchlist = this.Common.getStoreword() || [];
    for (var i = 0; i < this.storesearchlist.length; i++) {
      for (var m = 0; m < this.storesearchlist.length; m++) {
        if (i != m && this.storesearchlist[i] == this.storesearchlist[m]) {
          this.storesearchlist.splice(m, 1);
        }
      }
    }
    this.getList();
    this.getBrandList();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-379b3fcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/header.vue
var header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ng-header"},[_c('div',{staticClass:"w1200 top-header"},[_c('div',{staticClass:"ng-site-logo"},[_c('a',{attrs:{"href":_vm.CurrentEnvPrefix.main}},[_c('img',{attrs:{"src":_vm.CurrentEnvPrefix.qiniu +
                  '/data/upload/shop/common/' +
                  _vm.site_logo.value}})])]),_vm._v(" "),_c('div',{staticClass:"ng-head-search-bar",attrs:{"id":"search"},on:{"mouseleave":function($event){return _vm.hiddensearch()}}},[_c('ul',{staticClass:"ng-tab"},_vm._l((_vm.tab),function(tab,index){return _c('li',{key:tab,class:{ current: _vm.tabnum == index },on:{"click":function($event){return _vm.tabsearchClick(index, tab)}}},[_vm._v("\n              "+_vm._s(tab)+"\n            ")])}),0),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","display":"inline-block"}},[_c('div',{staticClass:"search-form"},[_c('input',{attrs:{"type":"hidden","name":"","value":"search"}}),_vm._v(" "),(_vm.tabnum == 0)?_c('input',{ref:"inputname",staticClass:"input-text",attrs:{"type":"text","name":"","placeholder":"请输入商品关键字"},on:{"click":function($event){return _vm.searchClick()}}}):_vm._e(),_vm._v(" "),(_vm.tabnum == 1)?_c('input',{ref:"inputname",staticClass:"input-text",attrs:{"type":"text","name":"","placeholder":"请输入厂家关键字"},on:{"click":function($event){return _vm.searchClick()}}}):_vm._e(),_vm._v(" "),_c('label',[_c('input',{staticClass:"input-submit",attrs:{"type":"submit","name":"","value":""},on:{"click":function($event){return _vm.searchsureClick()}}}),_vm._v(" "),_c('img',{staticStyle:{"position":"absolute","right":"23px","top":"3px","width":"30px","cursor":"pointer"},attrs:{"src":__webpack_require__("fma8")}})])]),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","cursor":"pointer","margin-left":"7px","overflow":"hidden","width":"106px","height":"40px","font-size":"12px","background-color":"#fff","color":"rgba(255, 46, 49, 1)","border-radius":"8px","border":"2px solid #FF3838","float":"left","line-height":"36px","text-align":"center"}},[_c('label',[_c('span',[_c('label',[_c('img',{staticStyle:{"width":"20px","vertical-align":"text-bottom"},attrs:{"src":__webpack_require__("a7FZ")}}),_vm._v("\n                    以图搜款"),_c('input',{ref:"upload",staticClass:"input-file",attrs:{"type":"file","id":"file","name":"card_z","accept":"image/png,image/jpeg,image/gif","hidefocus":"true"},on:{"change":_vm.uploadChange}})])]),_vm._v(" "),_c('input',{staticClass:"input-file",staticStyle:{"width":"0px","height":"26px","opacity":"0","cursor":"pointer","border":"0"},attrs:{"type":"file","name":"file_search","hidefocus":"true","size":"1"}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hotshow),expression:"hotshow"}],staticClass:"ng-search-tip"},[_c('div',{staticClass:"ng-search-history"},[_c('div',{staticClass:"ng-h-title"},[_vm._v("\n                历史记录"),_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.delword()}}},[_vm._v("清除")])]),_vm._v(" "),_c('ul',{staticClass:"ng-h-list",staticStyle:{"height":"82px","overflow":"hidden"}},_vm._l((_vm.searchlist),function(list){return (_vm.goodssearch)?_c('li',[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(list))])]):_vm._l((_vm.storesearchlist),function(list){return _c('li',[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(list))])])})}),0),_vm._v(" "),_c('div',{staticClass:"ng-h-title"},[_vm._v("好货推荐")]),_vm._v(" "),_c('div',{staticClass:"ng-h-goods"},[(_vm.list.ads)?_c('a',{attrs:{"href":_vm.list.ads[0].url,"title":_vm.list.adv_title}},[_c('img',{attrs:{"src":_vm.list.ads[0].pic}})]):_vm._e()])]),_vm._v(" "),(_vm.brandlist.length <= 6)?_c('div',{staticClass:"ng-search-hot"},[_c('div',{staticClass:"ng-h-title"},[_vm._v("热门推荐...")]),_vm._v(" "),_c('ul',{staticClass:"ng-hot-brand"},_vm._l((_vm.brandlist),function(list){return _c('li',[_c('a',{attrs:{"href":list.ads[0].url}},[_c('img',{attrs:{"src":list.ads[0].pic}})])])}),0)]):_vm._e(),_vm._v(" "),(_vm.brandlist.length > 6)?_c('div',{staticClass:"ng-search-hot1"},[_c('div',{staticClass:"ng-h-title"},[_vm._v("热门推荐...")]),_vm._v(" "),_c('ul',{staticClass:"ng-hot-brand1"},_vm._l((_vm.brandlist),function(list){return _c('li',[_c('a',{attrs:{"href":list.ads[0].url}},[_c('img',{attrs:{"src":list.ads[0].pic}})])])}),0)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"ng-keyword"},[_c('ul',_vm._l((_vm.goodskeyword),function(keyword){return _c('li',{on:{"click":function($event){return _vm.kwsearchClick(keyword)}}},[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(keyword))])])}),0)])])])])])}
var header_staticRenderFns = []
var header_esExports = { render: header_render, staticRenderFns: header_staticRenderFns }
/* harmony default export */ var public_header = (header_esExports);
// CONCATENATED MODULE: ./src/components/public/header.vue
function header_injectStyle (ssrContext) {
  __webpack_require__("ONTL")
}
var header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var header___vue_template_functional__ = false
/* styles */
var header___vue_styles__ = header_injectStyle
/* scopeId */
var header___vue_scopeId__ = "data-v-379b3fcc"
/* moduleIdentifier (server only) */
var header___vue_module_identifier__ = null
var header_Component = header_normalizeComponent(
  header,
  public_header,
  header___vue_template_functional__,
  header___vue_styles__,
  header___vue_scopeId__,
  header___vue_module_identifier__
)

/* harmony default export */ var components_public_header = (header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/public/publicnav.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var publicnav = ({
  data: function data() {
    return {
      cateVisible: false,
      activeCate: null,
      cateList: [],
      navList: [],
      showMoreList: false,
      // Vue2 模板无法访问 import 变量，挂到 data
      CurrentEnvPrefix: urlprefix["a" /* CurrentEnvPrefix */]
    };
  },

  computed: {
    firstNavList: function firstNavList() {
      return this.navList.filter(function (n) {
        return !n.is_more;
      });
    },
    moreNavList: function moreNavList() {
      return this.navList.filter(function (n) {
        return n.is_more;
      });
    }
  },
  created: function created() {
    this.queryCategory();
    this.queryNavList();
  },

  methods: {
    // 一级下是否存在三级（无三级时弹层二级按三级样式平铺展示）
    hasThirdChild: function hasThirdChild(list) {
      if (!list || !list.children) return false;
      return list.children.some(function (s) {
        return s.children && s.children.length > 0;
      });
    },

    // 展示分类树（首页/搜索页同源）
    queryCategory: function queryCategory() {
      var _this = this;

      fetch(urlprefix["a" /* CurrentEnvPrefix */].plapi + '/goods_display_class/get_display_class_nav?SystemName=pc&storeid=1').then(function (r) {
        return r.json();
      }).then(function (res) {
        if (Number(res.ResponseStatus) === 0) {
          _this.cateList = res.datas || [];
          if (_this.cateList.length) {
            _this.activeCate = _this.cateList[0];
          }
        }
      }).catch(function () {});
    },

    // 导航列表（laravel 接口，与 search 项目同源）
    queryNavList: function queryNavList() {
      var _this2 = this;

      fetch(urlprefix["a" /* CurrentEnvPrefix */].plapi + '/goods_search/search_nav?SystemName=pc&storeid=1').then(function (r) {
        return r.json();
      }).then(function (res) {
        if (Number(res.ResponseStatus) === 0) {
          _this2.navList = res.datas || [];
        }
      }).catch(function () {});
    },
    searchUrl: function searchUrl(id) {
      return urlprefix["a" /* CurrentEnvPrefix */].search + '/?d_gc_id=' + id;
    },
    goodsUrl: function goodsUrl(goodsId) {
      return urlprefix["a" /* CurrentEnvPrefix */].productionDetailUrl + '/?goods_id=' + goodsId;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-737c09dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/publicnav.vue
var publicnav_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pn-nav"},[_c('div',{staticClass:"pn-nav-inner"},[_c('div',{staticClass:"pn-cate",on:{"mouseenter":function($event){_vm.cateVisible = true},"mouseleave":function($event){_vm.cateVisible = false}}},[_c('span',{staticClass:"pn-cate-icon"},[_c('svg',{attrs:{"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none"}},[_c('path',{attrs:{"d":"M1 1h16M1 7h16M1 13h16","stroke":"#333","stroke-width":"2","stroke-linecap":"round"}})])]),_vm._v(" "),(_vm.cateVisible)?_c('div',{staticClass:"pn-popover"},[_c('div',{staticClass:"pn-popover-left"},[_c('ul',_vm._l((_vm.cateList),function(c){return _c('li',{key:c.d_gc_id,class:{ 'pn-active': _vm.activeCate && _vm.activeCate.d_gc_id === c.d_gc_id },on:{"mouseenter":function($event){_vm.activeCate = c}}},[_c('div',[_c('a',{staticClass:"pn-l1-link",attrs:{"href":_vm.searchUrl(c.d_gc_id)}},[_vm._v(_vm._s(c.d_gc_name))])]),_vm._v(" "),_c('div',{staticClass:"pn-second"},_vm._l((c.cn_classs || []),function(s){return _c('span',{key:s.d_gc_id},[_c('a',{attrs:{"href":_vm.searchUrl(s.d_gc_id)}},[_vm._v(_vm._s(s.d_gc_name))]),_vm._v(" "),_c('span',{staticClass:"pn-solidus"},[_vm._v("/")])])}),0),_vm._v(" "),_c('span',{staticClass:"pn-leftarrow"})])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeCate),expression:"activeCate"}],staticClass:"pn-popover-right"},[_c('div',{staticClass:"pn-popover-main"},[(_vm.hasThirdChild(_vm.activeCate))?_vm._l((_vm.activeCate ? _vm.activeCate.children || [] : []),function(s){return _c('div',{key:s.d_gc_id},[_c('div',{staticClass:"pn-second-title"},[_c('a',{attrs:{"href":_vm.searchUrl(s.d_gc_id)}},[_vm._v(_vm._s(s.d_gc_name))])]),_vm._v(" "),_c('div',{staticClass:"pn-third-list"},_vm._l((s.children || []),function(t){return _c('a',{key:t.d_gc_id,attrs:{"href":_vm.searchUrl(t.d_gc_id)}},[_vm._v("\n                    "+_vm._s(t.d_gc_name)+"\n                  ")])}),0)])}):_c('div',{staticClass:"pn-third-list"},_vm._l((_vm.activeCate ? _vm.activeCate.children || [] : []),function(s){return _c('a',{key:s.d_gc_id,attrs:{"href":_vm.searchUrl(s.d_gc_id)}},[_vm._v("\n                "+_vm._s(s.d_gc_name)+"\n              ")])}),0),_vm._v(" "),(_vm.activeCate && _vm.activeCate.recommend && _vm.activeCate.recommend.length)?_c('div',{staticClass:"pn-recommend"},[_c('div',{staticClass:"pn-recommend-title"},[_vm._v("新品推荐")]),_vm._v(" "),_c('div',{staticClass:"pn-recommend-list"},_vm._l((_vm.activeCate ? _vm.activeCate.recommend : []),function(r){return _c('div',{key:r.goods_ids,staticClass:"pn-recommend-item"},[_c('div',{staticClass:"pn-recommend-tags"},[_c('span',{staticClass:"pn-tag-main"},[_vm._v(_vm._s(r.title_middle_zhu))]),_vm._v(" "),(r.title_middle_ci)?_c('span',{staticClass:"pn-tag-sub"},[_vm._v(_vm._s(r.title_middle_ci))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"pn-recommend-imgs"},[(r.goods_ids_arr[0])?_c('a',{staticClass:"pn-img-big",attrs:{"href":_vm.goodsUrl(r.goods_ids.split(',')[0])}},[_c('img',{attrs:{"src":r.goods_ids_arr[0].goods_image,"alt":r.goods_ids_arr[0].goods_name}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pn-img-col"},_vm._l((r.goods_ids_arr.slice(1, 3)),function(g,gi){return _c('a',{key:gi,staticClass:"pn-img-small",attrs:{"href":_vm.goodsUrl(r.goods_ids.split(',')[gi + 1])}},[_c('img',{attrs:{"src":g.goods_image,"alt":g.goods_name}})])}),0)])])}),0)]):_vm._e()],2)])]):_vm._e()]),_vm._v(" "),_c('nav',{staticClass:"pn-navlist"},[_c('a',{staticClass:"pn-nav-link pn-nav-first",attrs:{"href":_vm.CurrentEnvPrefix.main}},[_vm._v("首页")]),_vm._v(" "),_vm._l((_vm.firstNavList),function(n){return [_c('a',{key:n.nav_id,staticClass:"pn-nav-link pn-nav-item",style:({
            fontSize: n.font_style && n.font_style['font-size'],
            fontWeight: n.font_style && n.font_style['font-weight'],
            color: n.font_style && n.font_style.color,
          }),attrs:{"target":"_blank","href":n.nav_url}},[_vm._v("\n          "+_vm._s(n.nav_title)+"\n          "),(n.nav_image)?_c('span',{staticClass:"pn-nav-image",style:({ background: 'url(' + n.nav_image + ') no-repeat center', backgroundSize: '100%' })}):_vm._e()])]}),_vm._v(" "),(_vm.moreNavList.length)?_c('div',{staticClass:"pn-more",on:{"mouseenter":function($event){_vm.showMoreList = true},"mouseleave":function($event){_vm.showMoreList = false}}},[_vm._v("\n        更多\n        "),_c('span',{staticClass:"pn-more-arrow",class:{ 'pn-more-arrow-open': _vm.showMoreList }},[_vm._v("▼")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMoreList),expression:"showMoreList"}],staticClass:"pn-more-list"},_vm._l((_vm.moreNavList),function(n){return _c('a',{key:n.nav_id,attrs:{"href":n.nav_url,"title":n.nav_title}},[_vm._v("\n            "+_vm._s(n.nav_title)+"\n          ")])}),0)]):_vm._e()],2)])])}
var publicnav_staticRenderFns = []
var publicnav_esExports = { render: publicnav_render, staticRenderFns: publicnav_staticRenderFns }
/* harmony default export */ var public_publicnav = (publicnav_esExports);
// CONCATENATED MODULE: ./src/components/public/publicnav.vue
function publicnav_injectStyle (ssrContext) {
  __webpack_require__("uBRC")
}
var publicnav_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var publicnav___vue_template_functional__ = false
/* styles */
var publicnav___vue_styles__ = publicnav_injectStyle
/* scopeId */
var publicnav___vue_scopeId__ = "data-v-737c09dc"
/* moduleIdentifier (server only) */
var publicnav___vue_module_identifier__ = null
var publicnav_Component = publicnav_normalizeComponent(
  publicnav,
  public_publicnav,
  publicnav___vue_template_functional__,
  publicnav___vue_styles__,
  publicnav___vue_scopeId__,
  publicnav___vue_module_identifier__
)

/* harmony default export */ var components_public_publicnav = (publicnav_Component.exports);

// EXTERNAL MODULE: ./src/global/js/htmldecode.js
var htmldecode = __webpack_require__("O55x");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/public/footer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var footer = ({
		data: function data() {
				return {
						setsearch: [],
						CurrentEnvPrefix: urlprefix["a" /* CurrentEnvPrefix */]
				};
		},

		methods: {
				getSetSearch: function getSetSearch() {
						var _this = this;

						var types = "all";
						var params = { types: types };
						this.$Api.get({ api: '/fragment/setting/search', param: params }).then(function (response) {
								var cont = response.data.datas;
								var set = [];
								cont.forEach(function (i, n, m) {
										if (i.key == 'statistics_code') {
												set.code = htmldecode["a" /* default */].htmlDecode(i.value);
										}
										if (i.key == 'site_email') {
												set.email = i.value;
										}
										if (i.key == 'site_phone') {
												set.phone = i.value;
										}
										if (i.key == 'site_logowx') {
												set.logowx = i.value;
										}
								});
								_this.setsearch = set;
						});
				}
		},
		mounted: function mounted() {
				this.getSetSearch();
		}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728989c5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/footer.vue
var footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ng-faq"},[_c('div',{staticClass:"w1100"},[_c('ul',{staticClass:"ng-help-ul"},[_c('li',{staticClass:"ng-help-li"},[_c('span',{staticClass:"ng-help-span"},[_vm._v("新手入门")]),_vm._v(" "),_c('ul',{staticClass:"ng-help-list"},[_c('li',[_c('a',{attrs:{"href":((_vm.CurrentEnvPrefix.main) + "/shop/index.php"),"target":"_blank'"}},[_vm._v("登录注册")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":((_vm.CurrentEnvPrefix.main) + "/shop/index.php?act=article&op=show&article_id=797"),"target":"_blank"}},[_vm._v("支付方式")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":((_vm.CurrentEnvPrefix.main) + "/shop/index.php?act=article&op=show&article_id=795"),"target":"_blank"}},[_vm._v("新手下单流程")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":((_vm.CurrentEnvPrefix.main) + "/shop/index.php?act=article&op=show&article_id=1595"),"target":"_blank"}},[_vm._v("关于我们")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":((_vm.CurrentEnvPrefix.main) + "/shop/index.php?act=article&op=show&article_id=1593"),"target":"_blank"}},[_vm._v("联系我们")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":((_vm.CurrentEnvPrefix.main) + "/shop/index.php?act=article&op=show&article_id=1591"),"target":"_blank"}},[_vm._v("招聘英才")])])])]),_vm._v(" "),_c('li',{staticClass:"ng-help-li"},[_c('span',{staticClass:"ng-help-span"},[_vm._v("店主之家")]),_vm._v(" "),_c('ul',{staticClass:"ng-help-list"},[_c('li',[_c('a',{attrs:{"href":((_vm.CurrentEnvPrefix.main) + "/shop/index.php?act=article&op=show&article_id=11"),"target":"_blank"}},[_vm._v("如何管理店铺")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":((_vm.CurrentEnvPrefix.main) + "/shop/index.php?act=article&op=show&article_id=671"),"target":"_blank"}},[_vm._v("QQ无法跳转")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":((_vm.CurrentEnvPrefix.main) + "/shop/index.php?act=article&op=show&article_id=813"),"target":"_blank"}},[_vm._v("电商城最\"惠\"招商")])])])]),_vm._v(" "),_c('li',{staticClass:"ng-help-li"},[_c('span',{staticClass:"ng-help-span"},[_vm._v("售后服务")]),_vm._v(" "),_c('ul',{staticClass:"ng-help-list"},[_c('li',[_c('a',{attrs:{"href":((_vm.CurrentEnvPrefix.main) + "/shop/index.php?act=article&op=show&article_id=809"),"target":"_blank"}},[_vm._v("快递查询")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":((_vm.CurrentEnvPrefix.main) + "/shop/index.php?act=article&op=show&article_id=26"),"target":"_blank"}},[_vm._v("联系卖家")])])])]),_vm._v(" "),_c('li',{staticClass:"ng-help-li"},[_c('span',{staticClass:"ng-help-span"},[_vm._v("特色功能")]),_vm._v(" "),_c('ul',{staticClass:"ng-help-list"},[_c('li',[_c('a',{attrs:{"href":((_vm.CurrentEnvPrefix.main) + "/shop/index.php?act=article&op=show&article_id=469"),"target":"_blank"}},[_vm._v("APP使用手册")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":((_vm.CurrentEnvPrefix.main) + "/shop/index.php?act=article&op=show&article_id=803"),"target":"_blank"}},[_vm._v("微商神器")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":((_vm.CurrentEnvPrefix.main) + "/shop/index.php?act=article&op=show&article_id=1367"),"target":"_blank"}},[_vm._v("找家纺代发说明")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":((_vm.CurrentEnvPrefix.main) + "/shop/index.php?act=article&op=show&article_id=1033"),"target":"_blank"}},[_vm._v("如何一键上传")])])])])]),_vm._v(" "),_c('div',{staticClass:"ng-help"},[_c('div',{staticClass:"contact-border"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"help-tel"},[_vm._v(_vm._s(_vm.setsearch.phone))]),_vm._v(" "),_c('p',{staticClass:"help-mail"},[_vm._v(_vm._s(_vm.setsearch.email))])])])])]),_vm._v(" "),_c('div',{staticClass:"ng-footer"},[_c('div',{staticClass:"w1200"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.setsearch.code)}},[_vm._v(_vm._s(_vm.setsearch.code))]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p')])])])}
var footer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-app"},[_c('img',{attrs:{"src":"http://www.zhaojiafang.com/shop/templates/default/images/1.jpg"}}),_vm._v(" "),_c('p',[_vm._v("找家纺App")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-app",staticStyle:{"margin-left":"35px"}},[_c('img',{attrs:{"src":"http://www.zhaojiafang.com/shop/templates/default/images/1.jpg"}}),_vm._v(" "),_c('p',[_vm._v("微信公众号")])])}]
var footer_esExports = { render: footer_render, staticRenderFns: footer_staticRenderFns }
/* harmony default export */ var public_footer = (footer_esExports);
// CONCATENATED MODULE: ./src/components/public/footer.vue
var footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var footer___vue_template_functional__ = false
/* styles */
var footer___vue_styles__ = null
/* scopeId */
var footer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var footer___vue_module_identifier__ = null
var footer_Component = footer_normalizeComponent(
  footer,
  public_footer,
  footer___vue_template_functional__,
  footer___vue_styles__,
  footer___vue_scopeId__,
  footer___vue_module_identifier__
)

/* harmony default export */ var components_public_footer = (footer_Component.exports);

// EXTERNAL MODULE: ./node_modules/echarts/index.js
var echarts = __webpack_require__("XLwt");
var echarts_default = /*#__PURE__*/__webpack_require__.n(echarts);

// EXTERNAL MODULE: ./node_modules/url/url.js
var url_url = __webpack_require__("UZ5h");
var url_default = /*#__PURE__*/__webpack_require__.n(url_url);

// EXTERNAL MODULE: ./node_modules/querystring-es3/index.js
var querystring_es3 = __webpack_require__("1nuA");
var querystring_es3_default = /*#__PURE__*/__webpack_require__.n(querystring_es3);

// EXTERNAL MODULE: ./config/appsetting.js
var appsetting = __webpack_require__("9F4c");
var appsetting_default = /*#__PURE__*/__webpack_require__.n(appsetting);

// CONCATENATED MODULE: ./src/global/js/mob_router.js








var appcontrollers = {
	// 这个是调用页面的方法 apphref://functionController/searchbyimage?param_gcid=fadfa
	APP_FUNC: { ios: 'functionController', android: 'functionActivity', wxapp: 'functionController', wap: 'functionController' },
	// 对应页面: h5
	APP_H5: { ios: 'html5WebViewController', android: 'H5Activity', wxapp: '/pages/webview/webview', wap: 'common/h5' },
	// 对应页面: 登录
	APP_LOGIN: { ios: 'NewLoginController', android: 'LoginActivity', wxapp: '/pages/login-register/login/login', wap: '/common/singon' },
	// 对应页面: 注册
	APP_REGISTER: { ios: 'RegisterController', android: 'RegisterActivity', wxapp: '/pages/login-register/forget/forgetpassword', wap: '/common/singin' },
	// 对应页面: 安全验证
	APP_SAFETY_CHECK: { ios: 'RegisterController', android: 'SafetyCheckActivity', wxapp: '', wap: '/common/safety' },
	// 对应页面: 绑定手机
	APP_BIND_PHONE: { ios: 'RegisterController', android: 'BindPhoneActivity', wxapp: '/pages/login-register/forget/forgetpassword', wap: '/common/bindphone' },
	// 对应页面: 找回登录密码
	APP_FORGET_PASSWORD: { ios: 'RegisterController', android: 'UpdatePasswordActivity', wxapp: '/pages/login-register/register/register', wap: '/common/findpassword' },
	// 对应页面: 找回支付密码
	APP_FORGET_PAY_PASSWORD: { ios: 'RegisterController', android: 'UpdatePayPasswordActivity', wxapp: '/pages/login-register/register/register', wap: '/common/paypassword' },
	// 对应页面: 商家列表
	APP_STORES: { ios: 'VenderListController', android: 'VenderActivity', wxapp: '/pages/vender/vender', wap: '/commodity' },
	// 对应页面：商家APP首页
	APP_STORE_TAB_INDEX: { ios: 'HomeStoreController', android: 'StoreHomeActivity', wxapp: '', wap: '/' },
	// 对应页面：店铺首页
	APP_STORE_INDEX: { ios: 'ShopHomeController', android: 'StoreDetailActivity', wxapp: '/pages/store/storeindex', wap: '/common/storehome' },
	// 对应页面：商城分类
	APP_GOODS_CLASS: { ios: 'GoodsClassViewController', android: 'GoodsClassActivity', wxapp: '/pages/searchGoods/search', wap: '/findgoods' },
	// 对应页面：店铺分类
	APP_STORE_CLASS: { ios: 'StoreClassController', android: 'StoreClassActivity', wxapp: '/pages/store/category/category', wap: '/common/subclass' },
	// 对应页面：购物车
	APP_CART: { ios: 'ShoppingCartController', android: 'CartActivity', wxapp: '/pages/cartlists/cartlist', wap: '/shoppingcate' },
	// 对应页面：商品列表
	APP_GOODS_LIST: { ios: 'GoodsListController', android: 'GoodsListActivity', wxapp: '/pages/goodslist/goodslist', wap: '/common/goodslist' },
	// 对应页面：商品详情
	APP_GOODS_DETAIL: { ios: 'GoodDetailController', android: 'GoodsDetailActivity', wxapp: '/pages/goodsdetail/goodsdetail', wap: '/common/goodsdetails/goodsdetail' },
	// 对应页面：个人中心
	APP_USER_CENTER: { ios: 'AccountSettingController', android: 'AccountActivity', wxapp: '/pages/usercenter/accountsetting/accountsetting', wap: '/accountsetting' },
	// 对应页面：个人中心 -> 订单列表
	APP_ORDER_LIST: { ios: 'OrderListController', android: 'OrderListActivity', wxapp: '/pages/usercenter/orderlist/orderlist', wap: '/common/order' },
	// 对应页面：个人中心 -> 订单详情
	APP_ORDER_DETAIL: { ios: 'OrderDetailController', android: 'OrderDetailActivity', wxapp: '/pages/usercenter/orderdetail/orderdetail', wap: '/common/orderdetailsdone' },
	// 对应页面：个人中心 -> 退款
	APP_REFUND: { ios: 'OrderRefundController', android: 'RefundableActivity', wxapp: '/pages/usercenter/orderrefund/orderrefund', wap: '/common/refundmoney' },
	// 对应页面：个人中心 -> 退款记录列表
	APP_REFUND_LIST: { ios: 'OrderRefundListController', android: 'RefundListActivity', wxapp: '/pages/usercenter/orderrefundlist/orderrefundlist', wap: '/common/refundlist' },
	// 对应页面：个人中心 -> 退款记录详情
	APP_REFUND_DETAIL: { ios: 'OrderRefundDetailController', android: 'RefundDetailActivity', wxapp: '/pages/usercenter/orderrefunddetail/orderrefunddetail', wap: '/common/refund' },
	// 对应页面：个人中心 -> 地址列表
	APP_ADDRESS_LIST: { ios: 'AddressListController', android: 'AddressListActivity', wxapp: '/pages/usercenter/addressctrl/addressctrl', wap: '/common/address' },
	// 对应页面：个人中心 -> 地址编辑
	APP_ADDRESS_EDIT: { ios: 'AddressEditController', android: 'AddressEditActivity', wxapp: '/pages/usercenter/editaddress/editaddress', wap: '/common/changeaddress' },
	// 对应页面：个人中心 -> 收藏商品
	APP_Favorite_GoodsList: { ios: 'FavoritesController', android: 'FavoriteListActivity', wxapp: '/pages/usercenter/collect/collect', wap: '/common/collection' },
	// 对应页面：个人中心 -> 关注店铺列表
	APP_Favorite_StoreList: { ios: 'AttentionController', android: 'FavoriteListActivity', wxapp: '/pages/usercenter/attention/attention', wap: '/common/follow' },
	// 对应页面：个人中心 -> 我的优惠券，代金券
	APP_Voucher_List: { ios: 'CouponController', android: 'CouponListActivity', wxapp: '', wap: '/common/mycoupons' },
	// 对应页面：个人中心 -> 浏览历史
	APP_History_List: { ios: 'HistoryController', android: 'BrowseListActivity', wxapp: '/pages/usercenter/scan/scan', wap: '/common/footprint' },
	// 对应页面：个人中心 -> 我的评价列表
	APP_Comment_List: { ios: 'DiscussController', android: 'MyCommentListActivity', wxapp: '/pages/usercenter/discuss/discuss', wap: '/common/myevaluate' },
	// 对应页面：个人中心 -> 我的平台客户咨询列表
	APP_MyConsult_List: { ios: 'MyConsultController', android: 'MallConsultActivity', wxapp: '/pages/usercenter/consult/consult', wap: '/common/consult' },
	// 对应页面：个人中心 -> 我的红包列表
	APP_Redpack_List: { ios: 'RedPackController', android: 'RedPacketListActivity', wxapp: '/pages/usercenter/redPack/redPack', wap: '/common/redpacket' },
	// 对应页面：个人中心 -> 消息总列表
	APP_NEWS_ALLList: { ios: 'AllNewsController', android: 'MessageActivity', wxapp: '/pages/usercenter/allNews/allnews', wap: '/common/mynews' },
	// 对应页面：个人中心 -> 我的账单
	APP_Bill_List: { ios: 'BillController', android: 'BillActivity', wxapp: '/pages/usercenter/billList/billlist', wap: '/common/balance' },
	// 对应页面：个人中心 -> 充值卡，账户 充值记录
	APP_PdRecharge_List: { ios: 'PdRechargeController', android: 'RechargeActivity', wxapp: '/pages/usercenter/PdRecharge/PdRecharge', wap: '/common/predeposit' },
	// 对应页面: 麦田代发
	APP_DAIFAI: { ios: 'MaitianAgencyController', android: 'DaiFaActivity', wxapp: '/pages/daifa/agencydaifa/agencydaifa', wap: '' },
	//文章主页
	APP_ATICLE_HOME: { ios: 'ArticlesHomeController', android: 'ArticleHomeActivity', wxapp: '', wap: '/common/articlelist' },
	//文章搜索列表
	APP_ATICLE_LIST: { ios: 'ArticleSearchListController', android: 'ArticleListActivity', wxapp: '', wap: '/common/articlesearch' },
	//文章详情
	APP_ATICLE_DETAIL: { ios: 'ArticleDetailViewController', android: 'ArticleDetailActivity', wxapp: '', wap: '/common/articledetail' }

	/* 	window.location.href
  *	@hrefpagetype : 跳转到app原生页面信息 (类型hrefPage)，可为空
  *  @shref : h5目标页面
  *  @appParams : app页面所需参数
  */
	// function hrefLocation(hrefpagetype, shref, appParams) {
	// 	var apppage;
	//   	// var isweixin = function(){ var ua = navigator.userAgent.toLowerCase(); return ua.match(/MicroMessenger/i) == "micromessenger" }
	//     if ( appversion>3.0 ) {
	//       var $url = shref;
	//       var strQuert = "";
	//       var params = querystring.parse(strQuert);
	//       if (params && params.act) {
	//         switch (params.act) {
	//             case 'goods':
	//                 $url = 'http://www.zhaojiafang.com/wap/tmpl/product_detail.html?1=1' + strQuert;
	//             break;
	//             case 'ads':
	//                 $url = 'http://www.zhaojiafang.com/wap/tmpl/ads_list.html';
	//             break;
	//             case 'store_list':
	//                 $url = 'http://www.zhaojiafang.com/wap/shop.html?1=1&' + strQuert;
	//             break;
	//             case 'search':
	//                 $url = 'http://www.zhaojiafang.com/wap/tmpl/product_list.html?1=1' + strQuert;
	//             break;
	//             case 'show_store':
	//                 if (params.op == 'store_article') {
	//                   $url = 'http://www.zhaojiafang.com/wap/tmpl/article_show.html?1=1' + strQuert;
	//                 }
	//                 else if(params.op == 'show_article'){
	//                   $url = 'http://www.zhaojiafang.com/wap/tmpl/article_show.html?1=1' + strQuert;
	//                 }
	//                 else if(params.op == 'goods_all' || params.op == 'goods_all_list'){
	//                   $url = 'http://www.zhaojiafang.com/wap/tmpl/product_goods.html?1=1' + strQuert;
	//                 }
	//                 else {
	//                   $url = 'http://www.zhaojiafang.com/wap/tmpl/product_store.html?1=1&store_id=' + params.store_id;
	//                 }
	//             break;
	//         }
	//       }

	//       var wta = { product_store: 'storeIndex', product_detail: 'goodsDetail', product_list:'goodsList', product_goods:'goodsList' }
	//       for(var k in wta){
	//         if ( $url && $url.indexOf( k + '.html' ) > -1 ){
	//             var wapquery = querystring.parse(strQuert);
	//             hrefpagetype = hrefPage[ wta[k] ];

	//             if (k == 'product_store') { appParams = { param_storeid: wapquery.store_id } }
	//             else if(k == 'product_detail'){ appParams = { param_goodsid: wapquery.goods_id } }
	//             else if(k == 'product_goods' || k == 'product_list'){
	//                 if (wapquery.gc_id) appParams = { param_gcid: wapquery.gc_id }; //apinfo.query += '&param_stcid=' + wapquery.stc_id;
	//                 if (wapquery.stc_id) appParams = { param_stcid: wapquery.stc_id }; //apinfo.query += '&param_stcid=' + wapquery.stc_id;
	//                 if (wapquery.store_id) appParams = { param_storeid: wapquery.store_id }; //apinfo.query += '&param_storeid=' + wapquery.store_id;
	//                 if (wapquery.keyword) appParams = { param_keyword: encodeURIComponent(wapquery.keyword || wapquery.inkeyword) }; //apinfo.query += '&param_keyword=' + encodeURIComponent(wapquery.keyword || wapquery.inkeyword); 

	//                 //添加筛选条件
	//                 if (wapquery.params_filters) {
	//                   appParams.params_filters = wapquery.params_filters
	//                 }
	//             }
	//         }
	//       }
	//     }

	// 	if (sfrom.toLowerCase() === fromWhere.ios) {
	// 		apppage = hrefpagetype.ios ? hrefpagetype.ios : hrefpagetype;
	//   		var _href = encodeURIComponent("apphref://"+apppage+"/app?zresource=m&"+$.param(appParams));
	// 		window.location.href = _href;
	// 	}
	// 	else {
	//   		apppage = hrefpagetype.android ? hrefpagetype.android : hrefpagetype;
	// 		if (window.control && apppage) {
	// 			window.control.pushpage(apppage , $.param(appParams));
	// 		}
	//       	else if(shref){ window.location.href = shref; }
	// 	}
	// }

};var HrefRouter = {
	// 格式化参数，加上统一参数
	_mob_toquery: function _mob_toquery(urlparams) {
		var squery = '';
		if (lodash_default.a.isString(urlparams)) {
			squery = urlparams;
		} else if (lodash_default.a.isObject(urlparams)) {
			lodash_default.a.map(urlparams, function (v, k) {
				squery += '&' + k + '=' + encodeURIComponent(v);
			});
		}
		squery += squery.indexOf('key') > 0 ? '' : '&key=' + memberinfo.getMemberInfo().key;
		// squery += squery.indexOf('isfrom')>0 ? '':'&isfrom=a';
		return squery;
	},
	// 根据服务器的的href来解析跳转
	_mob_pushRouter: function _mob_pushRouter(ctrl, href, func) {
		if (href.length == 0) {
			return;
		}

		var _url = url_default.a.parse(href);
		var ourl_params = querystring_es3_default.a.parse(_url.query);
		/*	如果过来的URL请求的是本地方法
   *	请求方式：functionController?zresource=n&params_func=functionTel&params_phone=400-101-1700 */
		if (_url.pathname == 'functionController') {
			switch (ourl_params.params_func) {
				case 'functionTel':
					{
						var tel = ourl_params.params_phone;
						window.location.href = 'tel://' + tel;
						return;
					}
					break;
				default:
					typeof func == 'function' && func(ourl_params);return;
					break;
			}
		} else if (ourl_params.phtml5url) {
			var _ph5url = ourl_params.phtml5url;delete ourl_params.phtml5url;
			_ph5url += _ph5url.indexOf('?') > 0 ? '' : '?zresource=m';
			window.location.href = _ph5url + this._mob_toquery(ourl_params);
		} else {
			var okctrl; //找到了的终端页面对像
			var keysForAppCtrl = keys_default()(appcontrollers);
			// 寻找对应Path，并跳转到指定终端页面
			for (var i = 0; i < lodash_default.a.size(keysForAppCtrl); i++) {
				var _k = keysForAppCtrl[i];
				var appctrl = appcontrollers[_k];
				if (appctrl.wap == _url.pathname) {
					okctrl = appctrl;
					break;
				}
			}
			if (!okctrl) {
				// 如果没有找到okctrl，被视为本地跳转，这时候要嫁接到APP上去 
				okctrl = appcontrollers.APP_H5;
				ourl_params.phtml5url = (_url.host || window.location.origin) + _url.pathname;
				if (ourl_params.title) ourl_params.ptitle = ourl_params.title;
				if (ourl_params.url) ourl_params.phtml5url = ourl_params.url;
				delete ourl_params.title;
				delete ourl_params.url;
			}
			if (okctrl) {
				if (common.getSourec().isFromApp && common.getSourec().isIos) {
					window.location.href = encodeURIComponent('apphref://' + okctrl.ios + '?zresource=n' + this._mob_toquery(ourl_params));
				} else if (common.getSourec().isFromApp && common.getSourec().isAndroid) {
					window.control.pushpage('apphref://' + okctrl.android + '?zresource=n' + this._mob_toquery(ourl_params));
				} else {
					// ctrl.$router.push({path: href});
					window.location.href = href;
				}
				return;
			}

			if (href.indexOf('http') != -1) {
				window.location.href = href;
				return;
			}
		}
	},
	WebHrefRrouter: function WebHrefRrouter(href) {
		window.location.href = href;
		// ctrl.$router.push({path:href,param:{a:1}});
	}
};

/* harmony default export */ var mob_router = (HrefRouter);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tianmao/identify.vue
//
//
//
//
//

/* harmony default export */ var identify = ({
  name: 'SIdentify',
  props: {
    identifyCode: {
      type: String,
      default: '1234'
    },
    fontSizeMin: {
      type: Number,
      default: 16
    },
    fontSizeMax: {
      type: Number,
      default: 40
    },
    backgroundColorMin: {
      type: Number,
      default: 180
    },
    backgroundColorMax: {
      type: Number,
      default: 240
    },
    colorMin: {
      type: Number,
      default: 50
    },
    colorMax: {
      type: Number,
      default: 160
    },
    lineColorMin: {
      type: Number,
      default: 40
    },
    lineColorMax: {
      type: Number,
      default: 180
    },
    dotColorMin: {
      type: Number,
      default: 0
    },
    dotColorMax: {
      type: Number,
      default: 255
    },
    contentWidth: {
      type: Number,
      default: 112
    },
    contentHeight: {
      type: Number,
      default: 38
    }
  },
  methods: {
    // 生成一个随机数
    randomNum: function randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },

    // 生成一个随机的颜色
    randomColor: function randomColor(min, max) {
      var r = this.randomNum(min, max);
      var g = this.randomNum(min, max);
      var b = this.randomNum(min, max);
      return 'rgb(' + r + ',' + g + ',' + b + ')';
    },
    drawPic: function drawPic() {
      var canvas = document.getElementById('s-canvas');
      var ctx = canvas.getContext('2d');
      ctx.textBaseline = 'bottom';
      // 绘制背景
      ctx.fillStyle = this.randomColor(this.backgroundColorMin, this.backgroundColorMax);
      ctx.fillRect(0, 0, this.contentWidth, this.contentHeight);
      // 绘制文字
      for (var i = 0; i < this.identifyCode.length; i++) {
        this.drawText(ctx, this.identifyCode[i], i);
      }
      this.drawLine(ctx);
      this.drawDot(ctx);
    },
    drawText: function drawText(ctx, txt, i) {
      ctx.fillStyle = this.randomColor(this.colorMin, this.colorMax);
      ctx.font = this.randomNum(this.fontSizeMin, this.fontSizeMax) + 'px SimHei';
      var x = (i + 1) * (this.contentWidth / (this.identifyCode.length + 1));
      var y = this.randomNum(this.fontSizeMax, this.contentHeight - 5);
      var deg = this.randomNum(-45, 45);
      // 修改坐标原点和旋转角度
      ctx.translate(x, y);
      ctx.rotate(deg * Math.PI / 180);
      ctx.fillText(txt, 0, 0);
      // 恢复坐标原点和旋转角度
      ctx.rotate(-deg * Math.PI / 180);
      ctx.translate(-x, -y);
    },
    drawLine: function drawLine(ctx) {
      // 绘制干扰线
      for (var i = 0; i < 8; i++) {
        ctx.strokeStyle = this.randomColor(this.lineColorMin, this.lineColorMax);
        ctx.beginPath();
        ctx.moveTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight));
        ctx.lineTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight));
        ctx.stroke();
      }
    },
    drawDot: function drawDot(ctx) {
      // 绘制干扰点
      for (var i = 0; i < 100; i++) {
        ctx.fillStyle = this.randomColor(0, 255);
        ctx.beginPath();
        ctx.arc(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight), 1, 0, 2 * Math.PI);
        ctx.fill();
      }
    }
  },
  watch: {
    identifyCode: function identifyCode() {
      this.drawPic();
    }
  },
  mounted: function mounted() {
    this.drawPic();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-575a8db5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tianmao/identify.vue
var identify_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-canvas"},[_c('canvas',{attrs:{"id":"s-canvas","width":_vm.contentWidth,"height":_vm.contentHeight}})])}
var identify_staticRenderFns = []
var identify_esExports = { render: identify_render, staticRenderFns: identify_staticRenderFns }
/* harmony default export */ var tianmao_identify = (identify_esExports);
// CONCATENATED MODULE: ./src/components/tianmao/identify.vue
var identify_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var identify___vue_template_functional__ = false
/* styles */
var identify___vue_styles__ = null
/* scopeId */
var identify___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var identify___vue_module_identifier__ = null
var identify_Component = identify_normalizeComponent(
  identify,
  tianmao_identify,
  identify___vue_template_functional__,
  identify___vue_styles__,
  identify___vue_scopeId__,
  identify___vue_module_identifier__
)

/* harmony default export */ var components_tianmao_identify = (identify_Component.exports);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./static/theme-#FF2D51/index.css
var theme__FF2D51 = __webpack_require__("N1Qb");
var theme__FF2D51_default = /*#__PURE__*/__webpack_require__.n(theme__FF2D51);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/vue-cookie/src/vue-cookie.js
var vue_cookie = __webpack_require__("K/Lq");
var vue_cookie_default = /*#__PURE__*/__webpack_require__.n(vue_cookie);

// CONCATENATED MODULE: ./src/global/js/adv.js


var adv_api = new api_API();
var UrlParamHash = function UrlParamHash(url) {
	var params = [],
	    h;
	if (url) {
		var hash = url.slice(url.indexOf("?") + 1).split('&');
		for (var i = 0; i < hash.length; i++) {
			h = hash[i].split("=");
			params[h[0]] = h[1];
		}
	}
	return params;
};

var adv = {

	bpeventadv: function bpeventadv(val, url) {
		var params = UrlParamHash(url);
		var goods_id = params['goods_id'] ? decodeURI(params['goods_id']) : '';
		var store_id = params['store_id'] ? decodeURI(params['store_id']) : '';
		if (goods_id) {
			val.goods_id = goods_id;
			val.direct_type = '商品详情';
		} else if (store_id) {
			val.store_id = store_id;
			val.direct_type = '店铺';
		} else {
			val.direct_type = '其他';
		}
		console.log(val);
		adv_api.post({ api: common.getSourec().extapi + '/tracking/addBpLog', param: { 'evt_name': '广告点击率统计', 'extInfo': val } }).then(function (response) {});
	}
};

/* harmony default export */ var js_adv = (adv);
// EXTERNAL MODULE: ./node_modules/vue-meta/dist/vue-meta.esm.js
var vue_meta_esm = __webpack_require__("f3bp");

// CONCATENATED MODULE: ./src/common-loader.js
// import { install } from '@zjf-mall/common-ui';

// 通过加载器始终加载最新的 CommonUI
(function () {
  var style = document.createElement('style');
  //:where 优先级为 0 用于在自定义元素未加载时占位，加载后会被覆盖
  style.innerHTML = '\n:where(zjf-header){\n  height: 30px;\n  display: block;\n}\n:where(zjf-nav){\n  height: 40px;\n  display: block;\n}\n';
  document.head.appendChild(style);

  var script = document.createElement('script');
  script.type = 'module';
  script.src = '//qiniu.zhaojiafang.com/data/upload/shop/common/package/npm-cdn/@zjf-mall/common-utils@latest/dist/scripts-loader.es.js';
  script.onload = function () {
    window.ZJFLibs.resolve('@zjf-mall/common-ui@latest').then(function (CommonUI) {
      CommonUI.install('zjf-', {
        platform: 'zjf',
        token: function token() {
          return js_cookie_default.a.get('zjf_token');
        },
        urlPrefix: "production"
      });
    });
  };
  document.body.appendChild(script);
})();
// CONCATENATED MODULE: ./src/main.js





























vue_esm["default"].use(vue_meta_esm["a" /* default */]);
vue_esm["default"].use(components_tianmao_identify);
vue_esm["default"].component('s-identify', components_tianmao_identify);
vue_esm["default"].prototype.$Api = new api_API();
vue_esm["default"].prototype.$ZJF = new api_ZJF();
vue_esm["default"].prototype.MemberInfo = memberinfo;
vue_esm["default"].prototype.Helper = js_helper;
vue_esm["default"].prototype.Common = common;
vue_esm["default"].prototype.adv = js_adv;
vue_esm["default"].prototype.$HrefRouter = mob_router;
vue_esm["default"].prototype.moment = moment_default.a;
vue_esm["default"].prototype.$cookie = vue_cookie_default.a;
vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(ydui_rem_default.a);
vue_esm["default"].use(vue_clipboard_default.a);
vue_esm["default"].use(element_ui_common_default.a);
vue_esm["default"].component('publictop', components_public_publictop);
vue_esm["default"].component('myheader', components_public_header);
vue_esm["default"].component('publicnav', components_public_publicnav);
vue_esm["default"].component('myfooter', components_public_footer);
/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  router: router,
  components: { App: src_App },
  template: '<App/>'
});

/***/ }),

/***/ "O55x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var HtmlUtil = {
    /*1.用浏览器内部转换器实现html转码*/
    htmlEncode: function htmlEncode(html) {
        //1.首先动态创建一个容器标签元素，如DIV
        var temp = document.createElement("div");
        //2.然后将要转换的字符串设置为这个元素的innerText(ie支持)或者textContent(火狐，google支持)
        temp.textContent != undefined ? temp.textContent = html : temp.innerText = html;
        //3.最后返回这个元素的innerHTML，即得到经过HTML编码转换的字符串了
        var output = temp.innerHTML;
        temp = null;
        return output;
    },
    /*2.用浏览器内部转换器实现html解码*/
    htmlDecode: function htmlDecode(text) {
        //1.首先动态创建一个容器标签元素，如DIV
        var temp = document.createElement("div");
        //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
        temp.innerHTML = text;
        //3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
        var output = temp.innerText || temp.textContent;
        temp = null;
        return output;
    },
    /*3.用正则表达式实现html转码*/
    htmlEncodeByRegExp: function htmlEncodeByRegExp(str) {
        var s = "";
        if (str.length == 0) return "";
        s = str.replace(/&/g, "&amp;");
        s = s.replace(/</g, "&lt;");
        s = s.replace(/>/g, "&gt;");
        s = s.replace(/ /g, "&nbsp;");
        s = s.replace(/\'/g, "&#39;");
        s = s.replace(/\"/g, "&quot;");
        return s;
    },
    /*4.用正则表达式实现html解码*/
    htmlDecodeByRegExp: function htmlDecodeByRegExp(str) {
        var s = "";
        if (str.length == 0) return "";
        s = str.replace(/&amp;/g, "&");
        s = s.replace(/&lt;/g, "<");
        s = s.replace(/&gt;/g, ">");
        s = s.replace(/&nbsp;/g, " ");
        s = s.replace(/&#39;/g, "\'");
        s = s.replace(/&quot;/g, "\"");
        return s;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (HtmlUtil);

/***/ }),

/***/ "ONTL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a7FZ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAhCAYAAACr8emlAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAHlSURBVFiFzZhRkoMgDIZ/Oh6Kt8aTFU9W+sat3AcTZB0tSbTd/WccxpaEryGG2ACl5hgfAJJ2fkcplDJpJgbNpDlGAvA8Q7QjFeSgdPYQpwBeXiLWnf0QgC5gN4Kb6I2hlOxGW33OABBK6a5fI8g5Biy/bE/5CjhWApDmGI/SZpK1hgYudZyqktooOvp8jjGFUqZhA5cODC5VKGWaYzz6mvhKc4wIHGbCsoWjdTHO0XvjXDQxTHb4lKDloXFq3sJOahDP8fxwqRSkLTM9sMyXOG8fOOKn1lUBzIA7cHsFN/NcwgJLAJ6S+Jb1bkY4auBSKCW8WzCUIttbbSzrmQGxbl22RILnZuBXvVVJDcjRI7711ESxSexLJUsEpZS4ThS2SRtfXVkAicdssDktaw4C57oZsU1aA08EvyoLYOZRnT8KX115AM+olimtgScHk8NGRDyq81gN2BZma7FlG2lOTWXKGsEkowWS5xLffu4s5igmvlVBbhtia5E3dzPcDRPWrpewJP1LFm/AU2Nq7mRcgAw5Nm97Aos3bbwLDnACAvVsDZv8kjHzBS+YyA0oYoBPvPEB8NXBr+qGa4+wq1RPnAELIGF9Ij+2XUrd0eRyAGqVpwODv1IOpYz1z5vmDew/qL7z/AApAdPV+6JpEwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "fNgU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fma8":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAA8CAYAAAA+CQlPAAAAAXNSR0IArs4c6QAABQ5JREFUaEPdm41xFTcQgHcrSFwBUAGmgoQKEioAKohdAaSCmAqACsAVABUAFSSuIE4Fy3yMziPklW6lu8s7P828GT9bf5/2Vz9WWbGY2c8i8ouInIrIryLCd34uy0cRuRaRLyLyUVU/rTiNUFcaqtWoZGb3ReQ3EXlWgYwO8V5E3qvq22iDJfWGwRPwiwS8ZA5lWzThQkReqSo/b1K6wTcE9hbgpaq+2oK8C9zM/hCRl8l25+aD3f6TPnldbB7bx0TuzXWS/MBzVcUfrFZC4MlpvRaR3xsjX2GjyU5xXrMlaQ994gjxE60C/JvZToMVZsHT5N41HBeSvVBVoIdLWtwzEeHzU6WjN6r6fHiQrGET3MxQyw8V1UbCZ0uBS4hsAXCcXlkFvgqeJP25Ak3IAXozr5sWHZPxpL8Y3gVPq46kveRjVVtrqW2aByZEUlQWwh1mMVRq4Nh06cj+43eqGnJcQ7OpNDIznNpT589PRk3tFriZsYp/OYM8PgT0NI8KPKb2SFUJm13lB/CGXZ+rKtnUQYuZoW2l2pPmPumdWAnuqdSlqrbid++Yw/WTzZPIlIlPt8rfgJsZSQQOLS+ErNMtvXfvKlTm+UVVH/X0lYN70v7fPHjPpM0MT19mel0+6Dt4su2/S2mrKvn07kplvl0mOYF7nnyX0p7x8g+iHn4CJ0PLk5WrvUo7A8fhkm/kJRx9tKI2b1WVE5VdFzMjfucePqzugHsr1x0eDrFCTlJzraonkbkAzsFCuRM62VMIq4GYGVrJOUFeyORmDy0AL7OhT6pKTN99STs4/FNeQtoKeOnY7gx4CsVWgP+pqmhxswBeNly03ZsbcO2/mxkblXzPPgwearg2wGh/jqmG5u9JPNRwdKJrt3PAQ6H4GMBXs/G7JvFh8LsczriY+Lcwn1DaiqqX29Huve3adhvtr7I3D21P73rmNpx1Au6dvISyn6hktqrnJF9fVdU7Er81hWlbWjqIUEjYCijSbzp/K+07nHxN4N5Rzq43KpUNSvjwZAL3tqa7DmtmxlFZfjTWdXiSHzaWOS/fOcrZ7H4sotJenYq0uwSVg3sesquzUZDedo606SJ83kblHJxkgKOc8nYytLHvnfxofTPjRoeXGXnpdsblTYp32sppBknBwVW+ouJcZt7vnZ93aQjow2JFF99Hj0p4atd4pBBKUcvxPXASgPI4h3YHg2/c14cTlllwKlRU6iDwgTc44didw7eegtQu4zEFUtruO+ledU/pNJcGON5W6Yafe/xTg8fRMdiil041kqTa05u66Hrx8uo8Wjny3KsGzxjs5Yn1qz0PMTOefJBTjFxYhv3QLHiyeS925osLOCt+GV3xvF6SMNe+LWDCFuZVRpxyyBB8CDzBk88j/drjO6phAiwCJoDHrd5omFn+vHvuxQULOt3l0f9i+DB4gkf9gPeeX7WEPb1prb1fr7VFyjzkvXl/k7QjAk8dnLCbeHWBZ8kEhxcsQOQR7oj2A4zWAH0renTAV7POIfBsAVBR0txeDWhJGOniL2ZT5Mb7t7x/F34ReLYAmACLwKd3Eb4mv4Bq8m8as8CFY2xFnanqLfhVwEvxpbyaxcjPv/g+qe1k85zodoF6qhKUPOOw2frucDcBHzHqpW0q29Wy2xv4owFPUcd7KODDL13pvbVvbLDyqV4elcQzZzsr+aMED2SaV0cLnuCJKt5/OZwfNXiWZpMUsQkiZ2ATc/ENsBxPe0WFZFoAAAAASUVORK5CYII="

/***/ }),

/***/ "l7hk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uBRC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.12fc346d8ecb0265a076.js